import React, { forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import './dropTarget.css';

const FileInput = forwardRef(({ children, multiple, ...props }, ref) => {
  const fallbackRef = useRef();
  const inputRef = ref || fallbackRef;

  const select = () => {
    inputRef.current.click();
  };

  return (
    <>
      <input type="file" hidden multiple={multiple} {...props} ref={inputRef} />
      {children({ select })}
    </>
  );
});

FileInput.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  multiple: PropTypes.bool,
};

FileInput.defaultProps = {
  multiple: false,
};

export default FileInput;
